var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticClass:"loading-overlay",attrs:{"value":_vm.isAppLoading,"color":_vm.color}},[_c('v-progress-circular',{staticClass:"loading-animation",attrs:{"indeterminate":"","size":250,"width":10}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }